import { TickBgGreenIcon } from "@/components/data-display/Icon";
import Image from "next/image";
import OrderNowBtn from "../button/OrderNowBtn";
import TakaIcon from "@/icons/taka-icon.svg";
import { useFetchSingleProduct } from "repo/product";
import { PET_TAG_DATA } from "@/utils/constants/pet-tag";
import InlineLoader from "@/icons/inline-loader.svg";

function EssentialRightSection({ onClick }) {
  const { isLoading, data: productData } = useFetchSingleProduct(
    PET_TAG_DATA.product
  );

  const productPrice =
    productData && productData.product.default_variation.price;
  const offerPrice =
    productData && productData.product.default_variation.offer_price;
  const offerPercentage =
    productData && productData.product.default_variation.offer_percent;
  const hasOffer =
    productData && productData.product.default_variation.offer_price > 0;

  return (
    <div className="lg:w-[50%] px-[1rem] lg:p-0 lg:mt-[4.5rem] relative flex flex-col pb-[2.438rem] lg:pb-0">
      <div className="absolute w-[63px] h-[63px] top-[3.3rem] right-[2rem] hidden lg:block">
        <Image
          src="/assets/pet-tag/essential-paw-right-top.svg"
          fill
          alt="Paw"
        />
      </div>

      <div className="absolute w-[134px] h-[134px] top-[12.3rem] right-[6.5rem] hidden lg:block">
        <Image
          src="/assets/pet-tag/essential-paw-right-mid.svg"
          fill
          alt="Paw"
        />
      </div>

      <div className="absolute w-[134px] h-[134px] bottom-0 right-[10rem] hidden lg:block">
        <Image
          src="/assets/pet-tag/essential-paw-right-bottom.svg"
          fill
          alt="Paw"
        />
      </div>

      <h1 className="max-w-[31.813rem] lg:text-[2.75rem] font-extrabold leading-[120%] mb-[1.5rem] text-[2rem] relative">
        The Essential Pet
        <br /> Tag for Every Adventure
      </h1>
      <p className="max-w-[33.25rem] leading-[160%] mb-[1.5rem] text-[1rem] lg:text-[1.25rem] relative">
        Keep your pet safe and sound with our cutting-edge QR-code pet tag.
        Designed with care, it’s more than just a tag—it’s a lifeline that
        ensures your pet always finds their way back home.
      </p>

      <div className="flex flex-col gap-[0.9rem] lg:gap-[1.125rem] mb-[2rem] lg:mb-[2.5rem] relative">
        <div className="flex flex-row items-center gap-[1.25rem] relative z-[10]">
          <TickBgGreenIcon className="w-[1.8rem] h-[1.8rem] lg:w-[2.25rem] lg:h-[2.25rem]" />
          <div className="text-[1rem] leading-[140%] lg:text-[1.25rem]">
            <h5 className="font-bold">Boosts Reunion Chances:</h5>
            <p>Increases the likelihood of a quick and happy reunion.</p>
          </div>
        </div>
        <div className="flex flex-row items-center gap-[1.25rem] relative z-[10]">
          <TickBgGreenIcon className="w-[1.8rem] h-[1.8rem] lg:w-[2.25rem] lg:h-[2.25rem]" />
          <div className="text-[1rem] leading-[140%] lg:text-[1.25rem]">
            <h5 className="font-bold">Helps Strangers Help Your Pet:</h5>
            <p>Easy for anyone to scan and get in touch with you.</p>
          </div>
        </div>
        <div className="flex flex-row items-center gap-[1.25rem] relative z-[10]">
          <TickBgGreenIcon className="w-[1.8rem] h-[1.8rem] lg:w-[2.25rem] lg:h-[2.25rem]" />
          <div className="text-[1rem] leading-[140%] lg:text-[1.25rem]">
            <h5 className="font-bold">Weatherproof Durability:</h5>
            <p>Tough enough to handle all your pet’s outdoor escapades.</p>
          </div>
        </div>
        <div className="flex flex-row items-center gap-[1.25rem] relative z-[10]">
          <TickBgGreenIcon className="w-[1.8rem] h-[1.8rem] lg:w-[2.25rem] lg:h-[2.25rem]" />
          <div className="text-[1rem] leading-[140%] lg:text-[1.25rem]">
            <h5 className="font-bold">Hassle-Free Design:</h5>
            <p>No batteries needed, ever.</p>
          </div>
        </div>
      </div>
      <div className="flex space-x-[24px] lg:space-x-[45px]">
        {!isLoading ? (
          <>
            <div className="flex items-center space-x-2">
              {hasOffer && (
                <div className="text-[1.5rem] lg:text-[2rem] font-medium text-[#8E4700] line-through">
                  <span>৳{productPrice}</span>
                </div>
              )}

              <div className="text-[2rem] lg:text-[2.75rem] font-extrabold text-[#050426] flex items-center space-x-1">
                <span>{hasOffer ? offerPrice : productPrice}</span> <TakaIcon />
              </div>
            </div>
            <OrderNowBtn
              onClick={onClick}
              btnText={
                hasOffer ? `Get ${offerPercentage}% Discount` : "Order Now"
              }
            />
          </>
        ) : (
          <div className="flex items-center space-x-2 text-white">
            <InlineLoader className="h-[4rem] w-[4rem]" />
          </div>
        )}
      </div>
    </div>
  );
}

export default EssentialRightSection;
